import "./App.css";

import Home from "./components/Home";

import NavBar2 from "./components/NavBar2";


import Contact from "./components/Contact";
import TechStack from "./components/TechStack";
import Testprojects from "./components/Testprojects";
import About from "./components/About";

import BackGround from "./components/Background";
import { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import Calendar from "./components/Calendar";

import GitHubStats from "./components/GitHubStats";




function App() {
  useEffect(() => {
    AOS.init();
  }, [])

  return (
    <div className="App">

    
      <NavBar2 id="nav-menu" />

      <BackGround/>
      <Home id="home" />

      <About id="about" classprops="about section" />
      <Testprojects id="projects" />
     
      <TechStack id="skills" />
      <Calendar/>
      <GitHubStats/>
      <Contact id="contact" />
    </div>
  );
}

export default App;
